export class Tab {
  constructor({ key, name }) {
    this.name = name;
    this.key = key;
  }
}
